<template>
  <form @submit.prevent="onCancel" class="col-sm-12">
    <div class="col-sm-12">
      <FieldTextArea name="Reason" :rows="6" placeholder="Type here" rules="required" v-model="value.revision" />
    </div>
    <div class="row mt-2">
      <div class="col-sm-12">
        <button type="submit" class="btn btn-orange w-100">Submit</button>
      </div>
    </div>
  </form>
</template>
<script>
import FieldTextArea from '@/components/field/TextArea.vue';

export default {
  name: "FormFeedbackCustomerIssue",
  components: {
    FieldTextArea
  },
  props: ['value'],
  methods: {
    async onCancel() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.$emit('cancel')
      }
    },
  }
}
</script>
